import {Component, Input, OnInit} from '@angular/core';
import {InfluencerCampaignPost} from '../../../models/influencer-campaign';
import {Router} from '@angular/router';

@Component({
  selector: 'campaign-post-item',
  templateUrl: './campaign-post-item.component.html',
  styleUrls: ['./campaign-post-item.component.scss']
})
export class CampaignPostItemComponent implements OnInit {
  @Input()
  post: InfluencerCampaignPost;
  @Input()
  campaignId: number;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  get campaignInfluencerImpact() {
    if (!this.post || !this.post.engagement || !this.post.reach) {
      return '0';
    }
    const engagement = this.post.engagement;
    const reach = this.post.reach;
    if (!reach || reach === 0 || !engagement || engagement === 0) {
      return '0';
    }
    const impact = (engagement * 100 / reach).toFixed(0);
    return impact;
  }

  openCampaignPost() {
    if (this.campaignId) {
      return this.router.navigate(['dashboard', 'post', this.post.urlHash]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/fb-testing-page/campaign-post-item/campaign-post-item.component.ts